// App root – delegates all routing, theming, and layout to router.tsx
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";

function App() {
  return <RouterProvider router={router} />;
}

export default App;
